import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectUBLDocumentTypeConstants } from "../../../../contabilidad/CatalogoDocumentosUBL/Selectores/SelectUBLDocumentTypeConstants";
import { InputDate } from "../../../../theme/Input/InputDate";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _ConsecutiveByUBLSoftwareDispatcher } from "../../../../../core/services/dataBean/EntityCatalogVdos";


interface Props {
    idUBLSoftwareDispatcher: number;
}

export const ConsecutiveByUBLSoftwareDispatcher = ({ idUBLSoftwareDispatcher }: Props) => {

    const consecutive = useDataBean(_ConsecutiveByUBLSoftwareDispatcher);
    const [form, setForm] = useState<any>({
        Date: _single.getCurrenDate(),
        UBLDocumentType: null
    })
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idUBLSoftwareDispatcher])

    const getLista = () => {

        consecutive.instance.getTaxEntityConsecutiveByUBLSoftwareDispatcher(idUBLSoftwareDispatcher, form.UBLDocumentType, form.Date).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        consecutive.setBean({
            // IDMacroProcess: IDMacroProcess
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {


    }
    const editaItem = () => {

        consecutive.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTaxEntityConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Facturador', property: 'AccountName', visible: true },
        { title: 'Tipo Documento', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Número de Autorización', property: 'AuthorizationNumber', visible: true },
        { title: 'Prefijo', property: 'NumerationPrefix', visible: true },
        { title: 'Valor Actual', property: 'SequenceActualValue', visible: true },
        { title: 'Consecutivo Inicial', property: 'InitialConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Consecutivo final', property: 'UptoConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Inicio', property: 'FromDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Autorización', property: 'AuthorizationDate', visible: true, mask: MASK_DATE },
        { title: 'Clave Técnica', property: 'TechnicalKey', visible: true },
        { title: 'Habilitado', property: 'IsEnabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Rangos de Numeración</label>
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-4">
                        <SelectUBLDocumentTypeConstants idSelect={form.UBLDocumentType} onChange={(e) => { setForm({ ...form, "UBLDocumentType": e }) }} label="Tipo de Documento" />
                    </div>
                    <div className="col-md-4">
                        <InputDate label="Fecha" value={form.Date} setDate={(e) => { setForm({ ...form, "Date": e }) }} name="Date" />
                    </div>
                    <div className="col-md-4 mt-3 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable body={lista} head={head} rowSet={consecutive.setBean} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}